import React from 'react';
import { Link } from 'react-router-dom';
import { useRegControls } from '../lib/regControls';

const LABEL = { creator: 'Creator', brand: 'Brand Booth', fnb: 'F&B' };

// Shows the registration form only while it is switched on in Dashboard > Otomasi.
export default function RegGate({ kind, children }) {
  const c = useRegControls();
  if (!c.loaded) return <div style={{ position: 'fixed', inset: 0, background: '#0F0A0A' }} />;
  if (c[kind] !== false) return children;
  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 20, background: '#E63329', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      <div data-testid="reg-closed" style={{ maxWidth: 440, width: '100%', background: '#fff', color: '#111', border: '3px solid #111', borderRadius: 20, boxShadow: '6px 6px 0 #111', padding: '28px 22px', textAlign: 'center' }}>
        <img src="/mascot/welcome.webp" alt="" style={{ height: 120, width: 'auto', margin: '0 auto 8px', display: 'block' }} />
        <h1 style={{ fontSize: 22, fontWeight: 900, margin: '0 0 8px' }}>Pendaftaran {LABEL[kind] || ''} sedang ditutup</h1>
        <p style={{ fontSize: 15, lineHeight: 1.6, margin: 0 }}>
          Terima kasih atas minatnya! Pendaftaran ini sedang tidak dibuka. Pantau Instagram Talesverse untuk info pembukaan berikutnya.
        </p>
        <Link to="/" style={{ display: 'inline-block', marginTop: 18, padding: '12px 20px', borderRadius: 14, background: '#111', color: '#fff', fontWeight: 800, textDecoration: 'none' }}>
          Kembali ke website
        </Link>
      </div>
    </div>
  );
}
